import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, from, map } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  return from(fetchAuthSession()).pipe(
    map((session) => {
      const isAuthenticated = session?.tokens?.idToken != null;
      if (!isAuthenticated) {
        router.navigate(['/public']);
      }
      return isAuthenticated;
    }),
    catchError((error) => {
      console.error('Error fetching session:', error);
      router.navigate(['/public']);
      return from([false]);
    })
  )
}